import React, { useState, useRef, useEffect } from 'react';
import { Input, Form, Select, Button } from 'Components';
import { useIntl } from 'react-intl';
import { useSelector } from "react-redux";

const EmissionCheck = (props) => {

  const { onSubmit, handleClose } = props;
  const { messages, locale } = useIntl();
  const editCreateDashboardGadgets = useRef();
  const [formData, setFormData] = useState({});
  const [thresholdSelected, setThresholdSelected] = useState('Hours');

  const optionsFrecuency = [{
    id: 300,
    name: `5 ${messages['dashboardPanel_edit_minutes']}`
  }, {
    id: 900,
    name: `15 ${messages['dashboardPanel_edit_minutes']}`
  }, {
    id: 1800,
    name: `30 ${messages['dashboardPanel_edit_minutes']}`
  },
  {
    id: 3600,
    name: `1 ${messages['dashboardPanel_edit_hours']}`
  },
  {
    id: 7200,
    name: `2 ${messages['hours']}`
  }];

  const {
    loadingCreateEdit,
    gadGet,
  } = useSelector((state) => state.dashboardPanelRedux);

  useEffect(() => {
    if (gadGet.hasOwnProperty('name')) {
      let settings = JSON.parse(gadGet.settings);
      setThresholdSelected(settings.thresholdSelected)
      setFormData({
        ...formData,
        name: gadGet.name,
        refreshSeconds: optionsFrecuency.filter(frecuency => frecuency.id === gadGet.refreshSeconds)[0]
      })
    } else {
      setFormData({
        ...formData
      })
    }
  }, [open, gadGet])

  useEffect(() => {
    if (formData?.fleet?.id) {
      setFormData({
        ...formData,
        refreshSeconds: optionsFrecuency.filter(frecuency => frecuency.id === formData.refreshSeconds.id)[0]
      })
    }
  }, [locale])

  useEffect(() => {
    if (gadGet.hasOwnProperty('name')) {
      let settings = JSON.parse(gadGet.settings);
      setThresholdSelected(settings.thresholdSelected)
      setFormData({
        ...formData,
        name: gadGet.name,
        refreshSeconds: optionsFrecuency.filter(frecuency => frecuency.id === gadGet.refreshSeconds)[0]
      })
    }
  }, [open, gadGet])

  const validateData = () => {
    onSubmit({
      ...formData,
      thresholdSelected: thresholdSelected,
      refreshSeconds: formData.refreshSeconds.id
    })
  }

  return (
    <div style={{ padding: '15px 20px 20px 20px' }}>
      <Form
        ref={editCreateDashboardGadgets}
        onValidSubmit={validateData}>
        <div>
          <Input
            id="name"
            value={formData.name || ""}
            onChange={(value) => {
              setFormData({ ...formData, name: value });
            }}
            label={messages['dashboardPanel_edit_title']}
            placeholder={messages['dashboardPanel_edit_title']}
            minLength={1}
            maxLength={25}
            type="text"
            required
            requiredMessage={messages['required_field']}
          />
        </div>
        <div style={{ paddingTop: 26 }}>
          <Select
            id="refreshSeconds"
            loading={loadingCreateEdit}
            options={optionsFrecuency}
            textField="name"
            valueField="id"
            label={messages['dashboardPanel_edit_frequency']}
            placeholder={messages['dashboardPanel_select']}
            isSearchable={false}
            value={formData.refreshSeconds}
            onChange={(value) => {
              setFormData({ ...formData, refreshSeconds: value });
            }}
            isClearable
            required
            requiredMessage={messages['required_field']}
          />
        </div>
      </Form>
      <div style={{
        bottom: 0,
        position: 'fixed',
        padding: 15
      }}>
        <Button
          disabled={loadingCreateEdit}
          className="btn-cancel"
          onClick={(e) => {
            if (e) e.preventDefault();
            handleClose();
          }}
        >
          {messages['cancel']}
        </Button>
        <Button
          disabled={loadingCreateEdit}
          onClick={(e) => {
            if (e) e.preventDefault();
            editCreateDashboardGadgets.current.submit();
          }}
          className="btn-blue"
        >
          {messages['save']}
        </Button>
      </div>
    </div>

  );
}

export default EmissionCheck;